import { inquiryStatusConfig, inquirySteps, BRAND } from "../types";
import type { InquiryStatus } from "../types";

export default function InquiryProgress({ status }: { status: InquiryStatus }) {
  const step = inquiryStatusConfig[status].step;
  return (
    <div className="flex items-center w-full">
      {inquirySteps.map((s, i) => (
        <div key={s} className="flex items-center flex-1 last:flex-none">
          <div className="flex flex-col items-center">
            <div
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: i <= step ? BRAND : "#E5E7EB" }}
            >
              {i < step ? (
                <i className="ri-check-line text-white" style={{ fontSize: 10 }} />
              ) : i === step ? (
                <div className="w-2 h-2 rounded-full bg-white" />
              ) : (
                <span className="font-bold text-gray-400" style={{ fontSize: 8 }}>{i + 1}</span>
              )}
            </div>
            <span
              className="mt-1 text-center leading-none whitespace-nowrap"
              style={{ fontSize: 9, color: i <= step ? BRAND : "#9CA3AF", fontWeight: i === step ? 700 : 400 }}
            >
              {s}
            </span>
          </div>
          {i < inquirySteps.length - 1 && (
            <div
              className="flex-1 h-px mb-3.5 mx-0.5"
              style={{ background: i < step ? BRAND : "#E5E7EB" }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
